
import React from 'react';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { useFeatures } from '@/hooks/useFeatures';

interface PropertyFeaturesSelectorProps {
  selectedFeatures: string[];
  onFeatureToggle: (featureId: string, checked: boolean) => void;
}

const PropertyFeaturesSelector = ({ selectedFeatures, onFeatureToggle }: PropertyFeaturesSelectorProps) => {
  const { data: allFeatures = [] } = useFeatures();

  // Group features by category
  const featuresByCategory = allFeatures.reduce((acc, feature) => {
    if (!acc[feature.category]) {
      acc[feature.category] = [];
    }
    acc[feature.category].push(feature);
    return acc;
  }, {} as Record<string, typeof allFeatures>);

  const categoryLabels: Record<string, string> = {
    amenities: 'Comodidades',
    connectivity: 'Conectividad',
    entertainment: 'Entretenimiento',
    comfort: 'Confort',
    laundry: 'Lavandería',
    safety: 'Seguridad',
    location: 'Ubicación',
    outdoor: 'Espacios exteriores',
    parking: 'Estacionamiento',
    general: 'General'
  };

  return (
    <div>
      <Label className="text-base font-semibold">Features</Label>
      <div className="mt-2 space-y-4 max-h-60 overflow-y-auto border rounded-lg p-4">
        {Object.entries(featuresByCategory).map(([category, features]) => (
          <div key={category}>
            <h4 className="font-medium text-sm text-gray-700 mb-2">
              {categoryLabels[category] || category}
            </h4>
            <div className="grid grid-cols-2 gap-2 ml-4">
              {features.map((feature) => (
                <div key={feature.id} className="flex items-center space-x-2">
                  <Checkbox
                    id={feature.id}
                    checked={selectedFeatures.includes(feature.id)}
                    onCheckedChange={(checked) => onFeatureToggle(feature.id, checked as boolean)}
                  />
                  <Label htmlFor={feature.id} className="text-sm">
                    {feature.name}
                  </Label>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PropertyFeaturesSelector;
